import React, { useState } from 'react';
import '../assets/business-category.css';

/* ─────────────────────────── Static modal data ─────────────────────────── */
const CATEGORY_DATA = {
  Lite: {
    description:
      'Didesain khusus untuk tipe SOHO (Small Office Home Office) yang membutuhkan solusi sederhana namun berkualitas. Smart Experience menyediakan paket internet dengan harga bersahabat tanpa batasan kuota, serta mengorbankan kualitas performa.',
    productSpec: [
      { label: 'Product Type',           value: 'Broadband Business' },
      { label: 'Last Mile Type',         value: 'Fiber Optic Lastmile' },
      { label: 'Cable Type',             value: 'Drop Core' },
      { label: 'Cable Length',           value: '300 M' },
      { label: 'Additional Cable (max)', value: '100 M (Add-On)' },
      { label: 'Additional Pole',        value: 'No' },
      { label: 'IP',                     value: 'Static Private' },
      { label: 'Router',                 value: 'ONT GPON Router' },
      { label: 'Access Point',           value: 'No', note: 'with Dia Band Wifi' },
      { label: 'Internet Quota',         value: 'Unlimited Internet Usage' },
      { label: '3rd Party On Site',      value: 'Yes' },
      { label: 'Survey On Site',         value: 'No' },
    ],
    sla: [
      { label: 'CIR',                                   value: '1:1' },
      { label: 'Bandwidth Ratio',                       value: '1:1', note: '(Up Down)' },
      { label: 'Availability',                          value: '95%' },
      { label: 'Resolution Time',                       value: '36 Hours' },
      { label: 'Troubleshooting Escalation',            value: '–' },
      { label: 'Activation Time',                       value: 'Max 1x24 Hours', note: '(After PR)' },
      { label: 'Monitoring',                            value: '24/7 Monitoring' },
      { label: '24/7 Customer Service',                 value: 'First Respons by BOT' },
      { label: '24/7 Heldesk Support',                  check: true },
      { label: '24/7 Technical Support',                check: true, note: 'Based on Priority – Dedicated Priority' },
      { label: 'Preventive Maintenance Notification',   check: true },
      { label: 'Early Notification System (Gamas)',     check: true },
    ],
    addOn: [
      { label: 'Additional Cable',      check: true },
      { label: 'Bandwidth Management',  check: true },
      { label: 'Basic System Hotspot',  check: true },
      { label: 'Access Point',          check: true },
    ],
  },
  Pro: {
    description:
      'Impressive Experience adalah solusi internet bagi Anda yang ingin mengembangkan bisnis dengan kestabilan dan kecepatan yang disesuaikan dengan skala bisnis Anda.',
    productSpec: [
      { label: 'Product Type',           value: 'Broadband Business' },
      { label: 'Last Mile Type',         value: 'Fiber Optic Lastmile' },
      { label: 'Cable Type',             value: 'Drop Core' },
      { label: 'Cable Length',           value: '500 M' },
      { label: 'Additional Cable (max)', value: '200 M (Add-On)' },
      { label: 'Additional Pole',        value: 'Yes' },
      { label: 'IP',                     value: 'Static Private' },
      { label: 'Router',                 value: 'ONT GPON Router' },
      { label: 'Access Point',           value: 'Yes', note: 'with Dia Band Wifi' },
      { label: 'Internet Quota',         value: 'Unlimited Internet Usage' },
      { label: '3rd Party On Site',      value: 'Yes' },
      { label: 'Survey On Site',         value: 'Yes' },
    ],
    sla: [
      { label: 'CIR',                                   value: '1:1' },
      { label: 'Bandwidth Ratio',                       value: '1:1', note: '(Up Down)' },
      { label: 'Availability',                          value: '99%' },
      { label: 'Resolution Time',                       value: '8 Hours' },
      { label: 'Troubleshooting Escalation',            value: 'Yes' },
      { label: 'Activation Time',                       value: 'Max 1x24 Hours', note: '(After PR)' },
      { label: 'Monitoring',                            value: '24/7 Monitoring' },
      { label: '24/7 Customer Service',                 value: 'First Respons by Agent' },
      { label: '24/7 Heldesk Support',                  check: true },
      { label: '24/7 Technical Support',                check: true, note: 'Based on Priority – Dedicated Priority' },
      { label: 'Preventive Maintenance Notification',   check: true },
      { label: 'Early Notification System (Gamas)',     check: true },
    ],
    addOn: [
      { label: 'Additional Cable',      check: true },
      { label: 'Bandwidth Management',  check: true },
      { label: 'Basic System Hotspot',  check: true },
      { label: 'Access Point',          check: true },
    ],
  },
  Prime: {
    description:
      'Merupakan solusi yang dirancang khusus untuk perkembangan bisnis Anda, dengan layanan profesional untuk memberikan pengalaman berbeda di kelasnya.',
    productSpec: [
      { label: 'Product Type',           value: 'Dedicated Business' },
      { label: 'Last Mile Type',         value: 'Fiber Optic Lastmile' },
      { label: 'Cable Type',             value: 'Drop Core / G652D' },
      { label: 'Cable Length',           value: 'Unlimited' },
      { label: 'Additional Cable (max)', value: 'Unlimited (Add-On)' },
      { label: 'Additional Pole',        value: 'Yes' },
      { label: 'IP',                     value: 'Static Public' },
      { label: 'Router',                 value: 'ONT GPON Router + CPE' },
      { label: 'Access Point',           value: 'Yes', note: 'Enterprise Grade' },
      { label: 'Internet Quota',         value: 'Unlimited Internet Usage' },
      { label: '3rd Party On Site',      value: 'Yes' },
      { label: 'Survey On Site',         value: 'Yes' },
    ],
    sla: [
      { label: 'CIR',                                   value: '1:1' },
      { label: 'Bandwidth Ratio',                       value: '1:1', note: '(Up Down)' },
      { label: 'Availability',                          value: '99.5%' },
      { label: 'Resolution Time',                       value: '4 Hours' },
      { label: 'Troubleshooting Escalation',            value: 'Yes – Priority' },
      { label: 'Activation Time',                       value: 'Max 1x24 Hours', note: '(After PR)' },
      { label: 'Monitoring',                            value: '24/7 Monitoring' },
      { label: '24/7 Customer Service',                 value: 'Dedicated Agent' },
      { label: '24/7 Heldesk Support',                  check: true },
      { label: '24/7 Technical Support',                check: true, note: 'Dedicated Priority' },
      { label: 'Preventive Maintenance Notification',   check: true },
      { label: 'Early Notification System (Gamas)',     check: true },
    ],
    addOn: [
      { label: 'Additional Cable',      check: true },
      { label: 'Bandwidth Management',  check: true },
      { label: 'Basic System Hotspot',  check: true },
      { label: 'Access Point',          check: true },
    ],
  },
};

const CARDS = ['Lite', 'Pro', 'Prime'];

/* ───────────────────────────── CheckIcon ──────────────────────────────── */
function CheckIcon() {
  return (
    <span className="bc-modal-check">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect width="16" height="16" rx="3" fill="#2ecc71"/>
        <path d="M3.5 8.5l3 3 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </span>
  );
}

/* ──────────────────────────── Modal Component ─────────────────────────── */
function CategoryModal({ category, onClose }) {
  if (!category) return null;

  const data = CATEGORY_DATA[category];
  if (!data) return null;

  return (
    <div className="bc-modal-overlay" onClick={onClose}>
      <div className="bc-modal-box" onClick={e => e.stopPropagation()}>

        {/* ── Header ── */}
        <div className="bc-modal-header">
          <h2 className="bc-modal-title">{category}</h2>
          <div className="bc-modal-header-divider" />
          <p className="bc-modal-header-desc">{data.description}</p>
        </div>

        {/* ── Body: 3 panels ── */}
        <div className="bc-modal-body">

          {/* Panel 1: Product Specification */}
          <div className="bc-modal-panel">
            <div className="bc-modal-panel-head">Product Spesification</div>
            <div className="bc-modal-panel-content">
              {data.productSpec.map((row, i) => (
                <div key={i} className="bc-modal-row">
                  <span className="bc-modal-row-label">{row.label}</span>
                  <span className="bc-modal-row-value">
                    {row.value}
                    {row.note && <small className="bc-modal-note">{row.note}</small>}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Panel 2: SLA */}
          <div className="bc-modal-panel">
            <div className="bc-modal-panel-head">SLA (Service Level Agreement)</div>
            <div className="bc-modal-panel-content">
              {data.sla.map((row, i) => (
                <div key={i} className="bc-modal-row">
                  <span className="bc-modal-row-label">{row.label}
                    {row.note && <small className="bc-modal-note">{row.note}</small>}
                  </span>
                  <span className="bc-modal-row-value">
                    {row.check ? <CheckIcon /> : row.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Panel 3: Add On */}
          <div className="bc-modal-panel bc-modal-panel--addon">
            <h4 className="bc-modal-addon-title">Add On</h4>
            <div className="bc-modal-addon-table">
              <div className="bc-modal-addon-thead">
                <span>Type</span>
                <span className="bc-modal-addon-divider">|</span>
                <span>{category.toUpperCase()}</span>
              </div>
              <div className="bc-modal-addon-tbody">
                {data.addOn.map((row, i) => (
                  <div key={i} className="bc-modal-addon-row">
                    <span className="bc-modal-row-label">{row.label}</span>
                    <span>{row.check ? <CheckIcon /> : '–'}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>

        {/* ── Footer ── */}
        <div className="bc-modal-footer">
          <button className="bc-modal-close-btn" onClick={onClose}>Close</button>
        </div>

      </div>
    </div>
  );
}

/* ──────────────────────── Business Category Cards ─────────────────────── */
export default function BusinessCategoryCards() {
  const [activeModal, setActiveModal] = useState(null);

  return (
    <>
      <div className="bc-cards-wrapper">
        {CARDS.map((title, i) => (
          <div key={i} className="bc-card">
            <h3 className="bc-card-title">{title}</h3>
            <hr className="bc-card-divider" />
            <div className="bc-card-desc">
              <div>{CATEGORY_DATA[title].description}</div>
            </div>
            <button
              className="bc-card-link"
              onClick={() => setActiveModal(title)}
            >
              Learn More &gt;
            </button>
          </div>
        ))}
      </div>

      <CategoryModal
        category={activeModal}
        onClose={() => setActiveModal(null)}
      />
    </>
  );
}
